import React from "react";
import HomeItem from "../components/Home/HomeItem";
const HomePage = () => {
  return <HomeItem />;
};

export default HomePage;
